import LayoutData from '@/services/data/LayoutData';
import { probePinsPointTypes } from '../../../pages/Sierra/constants';
import { getComponentsWithNetList } from '@/services/Sierra'
import DesignInfo from '@/services/Sierra/pcbInfo';
import RelateNetsGroup from "../../PCBHelper/relateNets";
import { strFormatChange, strReplaceAll } from "../../helper/stringHelper";
import { typeSort, getSignalName, getAdvanceConfig, SD } from './InterfaceHelper'
import { getInterDefaultName } from '@/services/helper/setDefaultName';
import { ESPI, QSPI, SPI, UART } from '../../PCBHelper/constants';
import { COMP_REPEATER, IC } from '../../PCBHelper';
import { getCompTypeByRepeaterPinMap } from '../interfaceData';
import _ from 'lodash';
import { getDefaultName } from '../../helper/setDefaultName';
import { getCompType } from '../../Designs/compTypeHelper';
import { SIERRA } from '../../../constants/pageType';
import { _maxPrefix } from '../../helper/split';

const SPIQSPIeSPI = 'SPI/QSPI/eSPI', I2S = 'I2S', CLKTYPE = 'CLK', CUSTOM = 'Custom';
class FindInterface {
  constructor(pcbId) {
    this.type = '';
    this.advancedConfig = {};
    this.pcbId = pcbId;

    this.LayoutData = null;
    this.netsList = [];
    this.layers = null;
    this.componentNetList = [];
    this.logList = [];
    this.logs = [];
    this.netNamePrefixStrList = []; //net name prefix item str: ["I2C","I3C"] -> "(I2C)|(I3C)"
    this.netNamePrefixRegList = [];//net name prefix reg: /(I2C)|(I3C)/ig
    this.excludeNetsRegList = null;//exclude nets name prefix reg list: [/(I3C)/ig, /(I2C)/ig]

    // interfaceKey - ICComps
    this.interfaceKeyICCompsMap = {};
  }

  autoFilterInterfacePcbSignalNets({ advancedConfig, component, pcbs, currentPcbSetting, interfaceType }) {
    const _advancedConfig = JSON.parse(JSON.stringify(advancedConfig || {}));
    const { type, netNamePrefix, isRegular, EXCLUDE, excludeIsRegular } = _advancedConfig;
    const { pcbId } = this;
    this.type = type;
    let netNameKeywords = netNamePrefix;
    if (interfaceType === CUSTOM) {
      this.type = interfaceType;
      netNameKeywords = _advancedConfig.netNameKeywords || [];
      _advancedConfig.netNamePrefix = netNameKeywords;
    }
    const { regList, strList } = this.setNetNamePrefixReg(netNameKeywords, isRegular) || {};
    this.netNamePrefixRegList = regList;
    this.netNamePrefixStrList = strList;
    this.excludeNetsRegList = this.getExcludeNetReg(EXCLUDE, excludeIsRegular);

    if (!this.netNamePrefixRegList || !this.netNamePrefixRegList.length) {
      return;
    }

    this.advancedConfig = { ..._advancedConfig };
    this.currentPcbSetting = currentPcbSetting;

    const pcbInfo = DesignInfo.getPCBInfo(pcbId);
    const { netsList = [], layers = [] } = pcbInfo || {}
    this.netsList = netsList || [];
    this.layers = layers || [];
    // Filter nets that match the net name prefix
    let filterNetList = this.getNetsByNetNamePrefix(netsList);
    // Filter nets that match the selected component
    this.filterNetsBySelectedComps(component, filterNetList);

    this.LayoutData = LayoutData.getLayout(pcbId);
    this.compPinsNets = LayoutData.getCompPinsNets(pcbId);

    let signalsInfo = this.getSignalsInfo(pcbs);
    return signalsInfo
  }

  getLogList = () => {
    this.logObj = [];
    if (!this.logList) {
      return []
    }
    let oneChipLogs = [], sameChipCompsLogs = [];
    for (let item of this.logList) {
      const level = this.getLogLevel(item.type);
      if (this.selectNets.includes(item.net)) {
        continue;
      }
      const isOneChip = item.type === "oneChip";
      const isSameChipComps = item.type === "sameChipComps";
      if (!this.logObj[item.net] || level > this.logObj[item.net].level) {

        if (isOneChip && !oneChipLogs.includes(item.log)) {
          oneChipLogs.push(item.log)
          this.logObj[item.net] = {
            level: level,
            log: item.log
          }
        } else if (isSameChipComps && !sameChipCompsLogs.includes(item.log)) {
          isSameChipComps.push(item.log)
          this.logObj[item.net] = {
            level: level,
            log: item.log
          }
        } else {
          this.logObj[item.net] = {
            level: level,
            log: item.log
          }
        }
      }
    }
    this.logs = Object.values(this.logObj).sort((a, b) => b.level - a.level).map(item => item.log);
    return this.logs;
  }

  getLogLevel = (level) => {
    switch (level) {
      case "NetNamePrefix":
        return 1;
      case "SignalNetNamePrefix":
        return 2;
      case "Component":
        return 3;
      case "Power":
        return 4;
      case "CLK":
        return 5;
      case "Data":
        return 6;
      case "DifferenceNets":
        return 7;
      case "DataGroup":
        return 8;
      case "EXCLUDE":
        return 9;
      case "oneChip":
        return 10;
      default: return 0;
    }
  }

  setNetNamePrefixReg = (netNamePrefix, isRegular) => {
    let netRegList = [], netStr = "", strList = [];
    if (isRegular) {
      for (let item of netNamePrefix || []) {
        const regItem = regularNetName(item)
        if (regItem === false) { continue }
        netRegList.push(regItem);
        strList.push(item.toString());
      }
      /* const _netNamePrefix = regularNetName(netNamePrefix)
      if (_netNamePrefix === false) { return null }
      netReg = _netNamePrefix;
      netStr = _netNamePrefix.toString(); */
    } else {
      const { reg, str } = getStrListReg(netNamePrefix, true);
      if (reg) {
        const netReg = regularNetName(reg);
        netStr = str;
        strList = [str];
        netRegList = [netReg]
      }
    }
    return { regList: netRegList, str: netStr, strList }
  }

  getExcludeNetReg = (EXCLUDE, excludeIsRegular) => {
    if (excludeIsRegular) {
      const regList = [];
      for (let item of EXCLUDE || []) {
        const regItem = regularNetName(item)
        if (regItem === false) { continue }
        regList.push(regItem);
      }
      return regList.length ? regList : null;
    } else {
      const reg = getStrListReg(EXCLUDE);
      return reg ? [reg] : null;
    }
  }

  getNetsByNetNamePrefix = (netsList) => {
    let filterNetList = [];
    for (let net of netsList) {
      if (!net.mGeomList.length && !net.mPinList.length && !net.mViaList.length) {
        continue;
      }

      if (this.netNamePrefixRegList.find(item => !!net.mName.match(item))) {
        filterNetList.push(net);
      } else {
        this.logList.push({
          type: "NetNamePrefix",
          net: net.mName,
          log: `Net "${net.mName}" does not contain either net name prefix keywords.`
        })
      }
    }
    return filterNetList;
  }

  filterNetsBySelectedComps = (component, filterNetList) => {
    let componentNetList = [], componentNetInfoList = [];
    if (component && Object.keys(component).length) {
      for (let data of filterNetList) {
        const { mName, mPinList } = data;
        for (let mPin of mPinList) {
          if (component.name === mPin.mCompName && !componentNetList.includes(mName)) {
            componentNetInfoList = [...componentNetInfoList, data]
            componentNetList = [...new Set([...componentNetList, mName])]
          } else if (component.name !== mPin.mCompName) {
            this.logList.push({
              type: "Component",
              net: mName,
              log: `Net "${mName}" is not connected to selected component ${component.name}.`
            })
          }
        }
      }
    } else {
      // find all comp
      componentNetList = filterNetList.map(item => item.mName)
      componentNetInfoList = [...filterNetList]
    }

    this.componentNetList = componentNetList;
    this.componentNetInfoList = componentNetInfoList;
  }

  getRelateNetsByName(netName, LayoutData, currentPcbSetting, type) {
    const { pcbId } = this;
    this.relatedGroups = new RelateNetsGroup();
    this.relatedGroups.setCompPinsNets(pcbId);
    if (type) { this.type = type }
    this.currentPcbSetting = currentPcbSetting
    const netInfo = LayoutData.mNetManager.GetNetFromName(netName);
    const { relateNets } = this.getRelateNetsByNetInfo(netInfo)
    return relateNets;
  }

  getCompType = (compName, pinLength, partName, COMP_PREFIX_LIB, compPinMap) => {
    return getCompType({
      compName,
      COMP_PREFIX_LIB,
      pinLength,
      partName,
      product: SIERRA,
      compPinMap
    })
  }

  getRelateNetsByNetInfo(checkNetInfo, isMulti) {
    let relatedList = this.relatedGroups.getRelatedNetsByNet({
      net: checkNetInfo,
      designId: this.pcbId,
      setupComps: this.components,
      type: this.type,
      filterInterfaceNetRule: (configInfo, mSymbolMgr) => this.getIsPowerGNDNets(configInfo, mSymbolMgr, this.advancedConfig),
      currentPcbSetting: this.currentPcbSetting,
      checkCompsTypeFunction: this.getCompType,
      isPowerGNDFn: this.simplePowerGndJudge,
      isMulti: true
    })
    const doNotStuff = this.currentPcbSetting.doNotStuff || [];

    let relatedInfoList = [];

    for (let relatedItem of relatedList) {
      const { relatedNets = [], netTargetComponents = [], rlcComponents = [], repeaterComponents = [] } = relatedItem || {};
      const icComponents = [...new Set(netTargetComponents.filter(item => !rlcComponents.includes(item) && !repeaterComponents.includes(item) && !doNotStuff.includes(item)))];

      let relateNets = [checkNetInfo.mName];
      if (relatedNets && relatedNets.length) {
        relateNets = [...new Set([checkNetInfo.mName, ...relatedNets])]
      }
      const findExist = relatedInfoList.find(item => !!_.isEqual(relateNets, item.relateNets));
      if (findExist) { continue }
      const findIncludeContent = relatedInfoList.find(it => !!relateNets.every(item => !!it.relateNets.includes(item)));
      if (findIncludeContent) { continue }
      const includeIndex = relatedInfoList.findIndex(item => !!item.relateNets.every(_it => relateNets.includes(_it)) && relateNets.length > item.relateNets.length);
      if (includeIndex > -1) {
        relatedInfoList.splice(includeIndex, 1)
      }
      relatedInfoList.push({
        relateNets,
        icComponents
      })
    }

    if (!relatedInfoList.length) {
      relatedInfoList.push({
        relateNets: [checkNetInfo.mName],
        icComponents: []
      })
    }

    if (isMulti) {
      return relatedInfoList
    }
    return relatedInfoList[0] || { relateNets: [], icComponents: [] };
  }

  simplePowerGndJudge(configInfo = {}) {
    const { mPinList = [], mViaList = [] } = configInfo;
    if (mPinList.length > 10 && mViaList.length > 10) {
      return true;
    }
    return false;
  }

  getIsPowerGNDNets(configInfo, mSymbolMgr, advancedConfig = {}) {
    const { netNamePrefix, isRegular, allowVoltageKeywords } = advancedConfig;
    const { mName } = configInfo;
    const { powerTableNets = [] } = this.currentPcbSetting || {};

    //net includes net name prefix list
    if (!isRegular && netNamePrefix && netNamePrefix.length && netNamePrefix.includes(mName)) {
      return false;
    }

    if (powerTableNets && powerTableNets.includes(mName)) {
      this.logList.push({
        type: "Power",
        net: mName,
        log: `Net "${mName}" exists in power nets table.`
      });
      return true;
    }

    //net includes voltage definition in auroraDB
    if (configInfo.mType === "Power") {
      this.logList.push({
        type: "Power",
        net: mName,
        log: `Net "${mName}" has voltage.`
      });
      return true;
    }

    //net is GND/VSS
    if (configInfo && mName.match(/^(?:GND|VSS|DGND)$/ig)) {
      this.logList.push({
        type: "Power",
        net: mName,
        log: `Net "${mName}" is a power/ground net.`
      });
      return true;
    }

    function matchNetNameVoltage(str) {
      if (str.match(/^\+v/ig) || str.match(/(VDD)|(VCC)|(GND)|(GROUND)/ig) || str.match(/\d+[PV]\d+/ig) || str.match(/[0-9]+V/ig)) {
        return true;
      }
      return false;
    }

    if (this.netNamePrefixRegList.find(it => !!mName.match(it))) {
      //net name match voltage and name prefix not match voltage
      if (!allowVoltageKeywords && matchNetNameVoltage(mName)) {

        const isPower = this.simplePowerGndJudge(configInfo);
        if (this.netNamePrefixStrList.find(str => matchNetNameVoltage(str)) && !isPower) {
          return false;
        } else {
          this.logList.push({
            type: "Power",
            net: mName,
            log: `Net "${mName}" is a power net (Includes voltage keywords${isPower ? " and the number of pins and vias is greater than 10" : ""}).`
          });
          return true;
        }
      }
      return false;
    }

    if (!allowVoltageKeywords && matchNetNameVoltage(mName)) {
      this.logList.push({
        type: "Power",
        net: mName,
        log: `Net "${mName}" is a power net (Includes voltage keywords).`
      });
      return true;
    }

    if (this.simplePowerGndJudge(configInfo)) {
      this.logList.push({
        type: "Power",
        net: mName,
        log: `Net "${mName}" is a power net (The number of pins and vias is greater than 10).`
      });
      return true;
    }

    return false;
  }

  getSignalsInfo(pcbs) {
    const { advancedConfig } = this;
    const { config, dataNameList, ISConnectTwoComp, types } = getAdvanceConfig(advancedConfig.type);
    this.selectNets = [];
    let _returnData = [];
    if (this.type === CUSTOM) {
      _returnData = this.getCustomSignals(pcbs)
      _returnData = this.addMergeSignalNameToSignals(_returnData, true);
      return _returnData;
    }

    if (config) {

      //CLK / Custom only search by net name prefix, other interface need to search clk/tx/rx/data signals
      let regList = [];
      if (config === "netNamePrefix") {
        //CLK / CUSTOM
        regList = this.netNamePrefixRegList;
      } else {
        //I2C/I3C/I3S/SPMI/SPI/QSPI/ESPI/UART
        const reg = getStrListReg(advancedConfig[config]);
        reg && regList.push(reg);
      }

      if (!regList || !regList.length) {
        return _returnData;
      }

      const signalGroupData = this.getCLKNetInfo({
        regList,
        pcbs,
        dataNameList,
        ISConnectTwoComp,
        types,
        clkKeys: advancedConfig[config]
      });

      if (signalGroupData && signalGroupData.length) {
        _returnData = [..._returnData, ...signalGroupData]
      }
    }
    if (advancedConfig.type === SPIQSPIeSPI) {
      _returnData = this.filterDataContent(_returnData)
    }
    _returnData = this.addMergeSignalNameToSignals(_returnData);

    return _returnData
  }

  addMergeSignalNameToSignals = (dataList, isCustom) => {
    // const componentList = getSierraLayoutComponents(this.layers); // { compName -> {pinList}}
    let signalNames = [];
    for (let i = 0; i < dataList.length; i++) {
      const _interface = dataList[i];
      _interface.interfaceKey = `${_interface.type}-${i}`;
      _interface.content.forEach((item, index) => {
        //item ->{name, nets:[]}
        const filterNets = item.nets.filter(it => it.match(item.name));
        let _filterNets = filterNets.length ? filterNets : [];
        if (!_filterNets.length) {
          //Filter N net: N12345679/48N45678
          _filterNets = item.nets.filter(it => !it.match(/^([0-9]*)N([0-9]+)$/ig))
        }
        _filterNets = _filterNets.length ? _filterNets.sort((a, b) => a.length - b.length) : [...item.nets].sort((a, b) => a.length - b.length);
        item.signalMergeName = /* isCustom ? item.name : */ _filterNets.length ? _filterNets[0] : item.nets[0];
        if (/* !isCustom &&  */signalNames.includes(item.signalMergeName)) {
          item.signalMergeName = getDefaultName({ nameList: signalNames, key: "", defaultKey: item.signalMergeName, firstIndex: 1, delimiter: "_" })
        }
        signalNames.push(item.signalMergeName);
        item.signalId = `${_interface.interfaceKey}::${item.signalMergeName}::${index}`;
      })
      this.interfaceKeyICCompsMap[_interface.interfaceKey] = _interface.ICComps;
      delete _interface.ICComps;
      dataList[i] = _interface;
    }
    return dataList;
  }

  getInterfaceKeyICCompsMap = () => {
    return this.interfaceKeyICCompsMap;
  }

  getAllDataSignalNets(dataNets, CLKNetCompListNames, ISConnectTwoComp, clkSignalNets, types) {
    let _dataNet = [], selectDataNets = [];
    for (let dataNet of dataNets) {
      const { nets } = dataNet;
      if (!nets || !nets.length || selectDataNets.includes(nets[0])) { continue }
      const configInfo = this.componentNetInfoList.find(item => item.mName === nets[0])
      let { relateNets: dataSignalNets, icComponents } = this.getRelateNetsByNetInfo(configInfo)
      dataSignalNets = dataSignalNets.filter(item => !clkSignalNets.includes(item))
      const { nets: _nets, excludeNets } = this.filterExcludeNets(dataSignalNets);
      dataSignalNets = _nets;
      const { icComps, sameComps } = this.getICComponents({
        nets: dataSignalNets,
        CLKNetCompListNames,
        icComponents,
        excludeNets
      });
      const isUART = types && types.length === 1 ? types[0] === UART : false;

      if ((icComps && icComps.length > 1) && (!sameComps || sameComps.length > 0)) {
        selectDataNets = [...selectDataNets, ...dataSignalNets];
        _dataNet.push({ ...dataNet, nets: [...dataSignalNets], dataNet: nets[0] });
      } else {
        icComps && icComps.length <= 1 && this.addOneChipNetsLog(dataSignalNets, icComps);
        sameComps && sameComps.length <= 0 && this.addGroupSameCompsLog({ dataSignalNets, icComps, CLKNetCompListNames, clkSignalNets, isUART });
      }
    }
    return _dataNet
  }

  findDataNet({ filterCLKNet, dataKey, clkData }) {
    // example: UART8_RXD  UART8_TXD
    const { componentNetList, advancedConfig } = this
    const replaceReg = new RegExp(clkData, "ig");
    let dataNet = filterCLKNet.replace(replaceReg, dataKey);
    if (componentNetList.includes(dataNet)) { return dataNet }

    //example: MCASP1_AXR5/UART8_RXD  MCASP1_AXR6/UART8_TXD
    /*  const netNameList = filterCLKNet.split("/");
     const name = netNameList.find(item => item.toLowerCase().includes(clkData.toLowerCase())) || "";
 
     const dataName = name.replace(replaceReg, dataKey);
     let newNameList = componentNetList.filter(item => item.toLowerCase().includes(dataName.toLowerCase()));
     let new_name = this.findDataName(newNameList, sameData, dataKey, filterCLKNet)
     if (new_name) {
       return new_name
     } */
    // const filterCLKNet = 'GPPC_C12_AUART1_RXD_ISH_UART1_RXD', clkData = 'RX', type = 'UART', dataKey = 'TX';
    // const rule = 'SPI|I2C'
    // const filterCLKNet = 'QUP0_SE4_I2C_SCL_SPI_MOSI', clkData = 'SCL', type = 'I2CI3C', dataKey = 'SDA', I2CI3C = 'I2CI3C';
    // const componentNetList = ['GPPC_B9_I2C5_SDA_ISH_I2C2_SDA', 'GPPC_B5_ISH_I2C0_SDA', 'GPPC_C16_I2C0_SDA', 'GPPC_C12_I2C0_SDA', 'GPPC_C12_I2C1_SDA', 'QUP0_SE4_I2C_SDA_SPI_MISO', 'QUP0_SE4_I2C_SCL_SPI_MOSI']
    // const netNamePrefix = ['I2C', 'I3C']

    const { isRegular, netNamePrefix } = advancedConfig;
    let matchName = null;
    const _rule = `${clkData}`;
    const _regObj = new RegExp('(' + _rule + ')', 'ig');
    if (!isRegular) {
      const new_rule = netNamePrefix.join('|');
      const netNamePrefixRegObj = new RegExp('((' + new_rule + ')(.*))', 'i');
      if (!filterCLKNet.match(netNamePrefixRegObj)) { return }
      matchName = filterCLKNet.match(netNamePrefixRegObj)[0];

      const sameData = filterCLKNet.split("_").filter(item => !item.match(_regObj));
      const _data = matchName.replace(_regObj, dataKey)
      /*   const newNameList = componentNetList.filter(item => tokenIncludes(item, _data)) */
      const newNameList = componentNetList.filter(item => item.toLowerCase().includes(_data.toLowerCase()))
      let new_name = this.findDataName(newNameList, sameData, dataKey, filterCLKNet)

      if (!new_name) {
        let filterData = filterCLKNet.split("_").filter(item => item.match(_regObj));
        filterData = [...new Set(filterData)]
        let newComponentNetList = [];
        filterData.forEach(item => {
          const newData = item.replace(_regObj, dataKey);
          let netList = []
          if (["SI", "SO", "DI", "DO", "IO"].includes(newData.toUpperCase()) || newData.length === 1) {
            const reg = new RegExp(`\\b${newData}\\b`, 'ig')
            netList = componentNetList.filter(item => item.match(reg))
          } else {
            netList = componentNetList.filter(item => item.toLowerCase().includes(newData.toLowerCase()))
          }

          newComponentNetList = [...new Set([...newComponentNetList, ...netList])]
        })
        new_name = this.findDataName(newComponentNetList, sameData, dataKey, filterCLKNet)
      }
      if (new_name) {
        return new_name
      }
    } else {
      const replaceCLKData = filterCLKNet.replace(_regObj, dataKey)
      const splitCLKNet = replaceCLKData.split('_');
      const bestMatchingNet = this.getBestMatchingNet(splitCLKNet, componentNetList, filterCLKNet, dataKey)
      if (bestMatchingNet) {
        return bestMatchingNet
      }
    }

  }

  getBestMatchingNet(splitCLKNet, componentNetList, filterCLKNet, dataKey) {
    let bestNetInfo = { number: 0, net: '' }
    for (let componentNet of componentNetList) {
      if (filterCLKNet === componentNet || !componentNet.includes(dataKey)) { continue }
      const splitNets = componentNet.split('_');
      const sameData = splitCLKNet.filter(it => splitNets.includes(it));
      if (!sameData.length) {
        continue;
      }
      if (sameData.length > bestNetInfo.number) {
        bestNetInfo = { number: sameData.length, net: componentNet }
      } else if (sameData.length === bestNetInfo.number && splitNets.length === splitCLKNet.length) {
        bestNetInfo = { number: sameData.length, net: componentNet }
      }
    }
    // if (bestNetInfo.number > splitCLKNet.length - 2) {
    //   return bestNetInfo.net
    // }
    return null
  }

  findDataName(nameList, sameData, dataKey, CLKNet) {
    if (nameList && nameList.length) {
      let MinDataSplitData = 0, MaxSameListLength = 0, netName, sameIndexKeysList = [];
      const dataReg = new RegExp(dataKey, "i");
      const clkNameKeys = CLKNet.split("_");
      // const a =Math.abs(8-10);
      const { netNamePrefix, isRegular } = this.advancedConfig;
      const netPrefix = isRegular ? this.netNamePrefixStrList : netNamePrefix.map(item => strFormatChange(item))
      const netPrefixRegList = netPrefix.map(str => new RegExp(`^${str}$`, "ig"))
      for (let newName of nameList) {
        const dataNetKeys = newName.split("_");
        const dataSplitData = newName.split("_").filter(item => !item.includes(dataKey) && !netPrefixRegList.find(reg => item.match(reg)));
        const same = arrHasSameValue(CLKNet, newName)
        const sameLength = same && same.length ? same.length : 0;
        const dataSplitDataLength = dataSplitData && dataSplitData.length ? dataSplitData.length : 0;
        if (sameLength === 0) {
          continue;
        }

        let sameKeysList = []
        for (let sameKey of same) {
          const clkIndex = clkNameKeys.findIndex(it => it === sameKey);
          const dataIndex = dataNetKeys.findIndex(it => it === sameKey);
          if (clkIndex === dataIndex) {
            sameKeysList.push(sameKey)
          }
        }
        /* if ((!MinDataSplitData || !MaxSameListLength) && newName.match(dataReg)) {
          MinDataSplitData = dataSplitDataLength;
          MaxSameListLength = sameLength;
          netName = newName
        } */

        if ((sameLength > MaxSameListLength) && newName.match(dataReg)) {
          MinDataSplitData = dataSplitDataLength;
          MaxSameListLength = sameLength;
          netName = newName;
          sameIndexKeysList = [...sameKeysList];
        } else if (sameLength === MaxSameListLength && newName.match(dataReg)) {
          let update = false;
          if (sameKeysList.length > sameIndexKeysList.length) {
            update = true;
          } else if (Math.abs(dataSplitDataLength - sameData.length) < Math.abs(MinDataSplitData - sameData.length) && sameKeysList.length >= sameIndexKeysList.length) {
            update = true;
          }
          if (update) {
            MinDataSplitData = dataSplitDataLength;
            MaxSameListLength = sameLength;
            netName = newName;
            sameIndexKeysList = [...sameKeysList];
          }
        }
      }
      return netName;
    }
  }

  getChipSelect({ filterCLKNet, allDataNets, CLKNetCompListNames, dataContent, clkKey, clkSignalNets }) {
    const { advancedConfig } = this;
    if (!advancedConfig.ChipSelect || !advancedConfig.ChipSelect.length) { return { chipSelectContent: [], chipSelectNetList: [] } }
    const splitClkData = filterCLKNet.split("_");
    const splitData = dataContent[0].nets[0].split("_");
    const filterData = splitClkData.filter(info => splitData.includes(info));
    let chipContent = [], chipSelectNetList = [];
    const netNameList = filterCLKNet.split("/");
    const filterCLKNetFindName = netNameList.find(item => item.toLowerCase().includes(clkKey.toLowerCase()))

    advancedConfig.ChipSelect.forEach(item => {
      let checkNetList = [], checkNetInfoList = [];
      if (filterData.length) {
        // filter eligible nets
        for (let configInfo of this.componentNetInfoList) {
          const { mName: compNet } = configInfo;
          if (compNet === filterCLKNet) { continue }
          const splitCompNetDates = compNet.split("_");
          const CompareData = filterData.filter(it => !splitCompNetDates.includes(it))
          const filterDiffData = splitCompNetDates.filter(it => !filterData.includes(it))
          if (!CompareData.length) {
            const filterNet = filterDiffData.filter(it => it.includes(item))
            if (filterNet && filterNet.length && !checkNetList.find(it => it.mName === compNet)) {
              checkNetList.push(configInfo)
            }
          } else {
            // const filterCLKNet = "MCASP2_AXR3/SPI3_CLK", compNet = 'MCASP2_AXR3/SPI3_CS3', clkKey = 'CLK', item = 'CS';
            const _dataName = filterCLKNetFindName.replace(clkKey, item)
            const configFindInfo = compNet.split("/").find(it => it.includes(item));
            const _reg = new RegExp('(^' + _dataName + '($|[0-9]))', 'i');
            if (_reg.test(configFindInfo) && !checkNetList.find(it => it.mName === compNet)) {
              checkNetList.push(configInfo)
            }
          }
        }

        let usedCheckNets = [];
        for (let checkNetInfo of checkNetList) {
          const { mName: checkNetName } = checkNetInfo;
          if (usedCheckNets.includes(checkNetName) || allDataNets.find(item => item.nets.includes(checkNetName)) || this.getIsPowerGNDNets(checkNetInfo, this.LayoutData.mSymbolMgr, advancedConfig)) { continue }
          let { relateNets: dataSignalNets, icComponents } = this.getRelateNetsByNetInfo(checkNetInfo)

          let continueList = []
          // Filter to find nets that have appeared before
          for (let dataSignalNet of dataSignalNets) {
            if (usedCheckNets.includes(dataSignalNet)) {
              continueList.push(dataSignalNet)
            }
          }
          if (continueList.length) { continue }
          const { nets, excludeNets } = this.filterExcludeNets(dataSignalNets);
          dataSignalNets = nets;
          const { icComps: _icComps, sameComps } = this.getICComponents({
            nets: dataSignalNets,
            icComponents,
            excludeNets,
            CLKNetCompListNames
          })
          if (_icComps && _icComps.length > 1 && (!sameComps || sameComps.length > 0)) {
            usedCheckNets = [...usedCheckNets, ...dataSignalNets]
            checkNetInfoList.push({ nets: [...dataSignalNets], dataNet: checkNetName })
          } else {
            _icComps && _icComps.length <= 1 && this.addOneChipNetsLog(dataSignalNets, _icComps);
            sameComps && sameComps.length <= 0 && this.addGroupSameCompsLog({ dataSignalNets, icComps: _icComps, CLKNetCompListNames, clkSignalNets });
          }
        }
      }

      if (checkNetInfoList.length > 1) {
        const _reg = new RegExp('(^' + item + '($|[0-9]))', 'i');
        let nameList = [];
        checkNetInfoList.forEach((it, index) => {
          const findName = it.nets[0].split('_').find(splitInfo => _reg.test(splitInfo))
          let name = findName && !nameList.includes(findName) ? findName : `${item}${index}`
          nameList.push(name)
          chipContent.push({ name: name, nets: it.nets, dataNet: it.dataNet })
          chipSelectNetList = [...chipSelectNetList, ...it.nets]
        })
      } else if (checkNetInfoList.length === 1) {
        chipContent.push({ name: item, nets: checkNetInfoList[0].nets, dataNet: checkNetInfoList[0].dataNet })
        chipSelectNetList = [...chipSelectNetList, ...checkNetInfoList[0].nets]
      }
    })
    return { chipSelectContent: chipContent, chipSelectNetList }
  }

  getICComponents = ({ nets, CLKNetCompListNames, excludeNets, icComponents }) => {
    if (icComponents && icComponents.length && !CLKNetCompListNames && (!excludeNets || !excludeNets.length)) {
      return { icComps: icComponents };
    }
    const { netsList, layers, pcbId, currentPcbSetting } = this;
    const { compPrefixLib, doNotStuff, compPinMap, passiveTable } = currentPcbSetting;
    const componentsList = getComponentsWithNetList({
      netList: nets || [],
      pcbNetsList: netsList,
      layers,
      pcbId,
      COMP_PREFIX_LIB: compPrefixLib,
      doNotStuff,
      passiveTable,
      compPinMap
    });
    const filterRepeater = componentsList.filter(item => item.type === COMP_REPEATER);
    const icComps = []
    if (filterRepeater && filterRepeater.length) {
      for (let item of filterRepeater) {
        const pins = componentsList.filter(it => it.name === item.name);
        const type = getCompTypeByRepeaterPinMap({ type: item.type, part: item.part, pins, compPinMap, compName: item.name });
        type === IC && icComps.push(item.name)
      }
    }

    const _filterData = componentsList.filter(compNet => probePinsPointTypes.includes(compNet.type));

    const allICComps = [...new Set([..._filterData.map(item => item.name), ...icComps])];
    if (allICComps.length <= 1) {
      return { icComps: allICComps }
    }

    if (CLKNetCompListNames && CLKNetCompListNames.length) {
      const filterCLKComps = allICComps.filter(it => CLKNetCompListNames.includes(it));
      return { icComps: allICComps, sameComps: filterCLKComps }
    }
    return { icComps: allICComps }
  }

  filterNetsByCLKKeywords = (regList, types, sigName) => {
    let filterConfigNetList = [];
    const { advancedConfig, type, componentNetInfoList } = this;
    if ([CLKTYPE].includes(type)) {
      //rule - filter net name includes
      /* let rule = type === CLKTYPE ? /(SCLK)|(I2C)|(I3C)|(SPI)|(GPIO)|(I2S)/ : null; */
      const isDifferential = advancedConfig.isDifferential ? advancedConfig.isDifferential : false;
      filterConfigNetList = this.getCLKTypeClkNet({ isDifferential })
    } else {
      filterConfigNetList = componentNetInfoList.filter(item => {
        if (regList.find(it => !!item.mName.match(it))) {
          return item;
        } else {
          const isUART = types && types.includes(UART);
          const isCUSTOM = types && types.includes(CUSTOM);
          const title = isUART ? "TX" : isCUSTOM ? sigName || "Custom" : "CLK";
          this.logList.push({
            type: "CLK",
            net: item.mName,
            log: `Net "${item.mName}" does not contain either ${title} keywords.`
          });
          return false;
        }
      })
      if (type === I2S) {
        // If WS and CLK and MCLK have similar parts, place the net that meets WS and MCLK at the back of the team
        const wsNetNameReg = getStrListReg([...advancedConfig.WS, ...advancedConfig.MCLK]);
        filterConfigNetList = filterConfigNetList.sort((a, b) => {
          return wsNetNameReg.test(b.mName) ? -1 : 1
        })
      }
    }
    return filterConfigNetList;
  }

  getExcludeNets = (nets) => {
    if (this.excludeNetsRegList && this.excludeNetsRegList) {
      const filterNets = nets.filter(item => this.excludeNetsRegList.find(it => item.match(it)));
      return filterNets.length ? filterNets : false;
    }
    return false;
  }

  filterExcludeNets = (nets) => {
    const excludeNets = this.getExcludeNets(nets);
    if (excludeNets && excludeNets.length) {
      nets = nets.filter(item => !excludeNets.includes(item));
      for (let net of excludeNets) {
        this.logList.push({
          type: "EXCLUDE",
          net: net,
          log: `Net "${net}" is a EXCLUDE net.`
        });
      }
    }
    return { nets, excludeNets }
  }

  addOneChipNetsLog = (nets, icComps, netType, clkSignalNets, isUART) => {
    const netStr = nets.join(", ");
    const clkNetStr = (clkSignalNets || []).join(", ");
    const compStr = (icComps || []).join(", ")
    let log = `The signal - [ ${netStr} ] is only connected to one chip component - [ ${compStr} ]. Please check the DNS list in the 'Components & Nets' Setting if this is unexpected.`;
    if (netType === "data") {
      const clkKey = isUART ? 'TX' : "CLk", dataKey = isUART ? 'RX' : 'Data';
      log = `The ${clkKey} signal - [ ${clkNetStr} ] in the same group as the ${dataKey} signal - [${netStr}] is only connected to one chip component - [ ${compStr} ]. Please check the DNS list in the 'Components & Nets' Setting if this is unexpected.`;
    }
    for (let net of nets) {
      this.logList.push({
        type: "oneChip",
        net: net,
        log
      });
    }
  }

  addGroupSameCompsLog = ({ dataSignalNets, icComps, CLKNetCompListNames, clkSignalNets, isUART }) => {
    const netStr = dataSignalNets.join(", ");
    const clkNetStr = (clkSignalNets || []).join(", ");
    const compStr = (icComps || []).join(", "),
      clkCompStr = (CLKNetCompListNames || []).join(", ");
    const clkKey = isUART ? 'TX' : "CLk", dataKey = isUART ? 'RX' : 'Data';

    const log = `The ${clkKey} signal - [ ${clkNetStr} ] and ${dataKey} signal -[ ${netStr} ] do not share common chip components. components of the ${clkKey} signal - [ ${clkCompStr} ] , components of the ${dataKey} signal - [ ${compStr} ]`;

    for (let net of dataSignalNets) {
      this.logList.push({
        type: "sameChipComps",
        net: net,
        log
      });
    }
  }

  getCLKNetInfo({
    regList,
    clkKeys,
    pcbs,
    dataNameList,
    ISConnectTwoComp,
    types
  }) {
    const { advancedConfig, pcbId, type, componentNetList } = this;

    let filterConfigNetList = this.filterNetsByCLKKeywords(regList, types);
    let _returnData = [];

    for (let configInfo of filterConfigNetList) {
      const { mName: filterCLKNet } = configInfo;
      /*  if (this.selectNets.includes(filterCLKNet)) { continue } */
      const { excludeNets: clkExcludeNets } = this.filterExcludeNets([filterCLKNet]);
      if (clkExcludeNets && clkExcludeNets.includes(filterCLKNet)) {
        continue;
      }
      if (this.getIsPowerGNDNets(configInfo, this.LayoutData.mSymbolMgr, advancedConfig)) { continue }
      this.relatedGroups = new RelateNetsGroup();
      this.relatedGroups.setCompPinsNets(this.pcbId);

      let content = [], _interfaceType = '';
      if (type === CLKTYPE) {
        let relatedList = this.getRelateNetsByNetInfo(configInfo, true);

        for (let relateItem of relatedList) {
          let { relateNets: clkSignalNets, icComponents } = relateItem || {};

          const { nets, excludeNets } = this.filterExcludeNets(clkSignalNets);
          clkSignalNets = nets;
          const findContent = _returnData.find(it => !!it.content.find(item => _.isEqual([...clkSignalNets].sort(), [...item.nets].sort())))
          if (findContent) { continue }
          const findIncludeContent = _returnData.find(it => !!it.content.find(item => clkSignalNets.every(_it => item.nets.includes(_it))))
          if (findIncludeContent) { continue }
          _interfaceType = type;
          let name = filterCLKNet;
          if (advancedConfig.isRegular) {
            const findName = regList.find(item => filterCLKNet.match(item));
            const _name = findName ? filterCLKNet : type;

            const nameList = clkSignalNets.filter(item => !!regList.find(reg => item.match(reg))).sort((a, b) => a.length - b.length);
            name = nameList && nameList[0] ? nameList[0] : _name;
          } else {
            name = clkKeys.find(item => !!filterCLKNet.toLowerCase().includes(item.toLowerCase())) || clkKeys[0];
          }
          const { icComps } = this.getICComponents({
            nets: clkSignalNets,
            excludeNets,
            icComponents
          })
          if (icComps && icComps.length > 1) {
            //remove exist signal 
            const includeIndex = _returnData.findIndex(it => !!it.content.find(item => item.nets.every(_it => clkSignalNets.includes(_it)) && clkSignalNets.length > item.nets.length));
            if (includeIndex > -1) {
              _returnData.splice(includeIndex, 1)
            }
            this.selectNets = [...this.selectNets, filterCLKNet, ...clkSignalNets];
            _returnData.push({
              content: [{
                name, nets: [...clkSignalNets]
              }],
              pcbs,
              pcbId,
              type: _interfaceType,
              ICComps: icComps
            })
          } else {
            this.addOneChipNetsLog(clkSignalNets, icComps);
          }
        }
      } else {
        if (this.selectNets.includes(filterCLKNet)) { continue }
        let { relateNets: clkSignalNets, icComponents } = this.getRelateNetsByNetInfo(configInfo)

        const { nets } = this.filterExcludeNets(clkSignalNets);
        clkSignalNets = nets;
        const filterClkKeys = clkKeys.filter(item => { const _reg = new RegExp(item, "ig"); return filterCLKNet.match(_reg) }).sort((a, b) => b.length - a.length);
        const clkKey = filterClkKeys[0] || clkKeys[0];

        let _componentNetList = [...componentNetList]
        //get data signals by clk
        const { dataContent, dataSignalNetList, interfaceType, newClkSignalNets } = this.getDataNetInfo({
          dataNameList,
          filterCLKNet,
          clkKey,
          clkSignalNets,
          ISConnectTwoComp,
          types,
          componentNetList: _componentNetList
        })
        if (newClkSignalNets && newClkSignalNets.length) {
          clkSignalNets = [...newClkSignalNets]
        }

        let ICComps = [];
        if (dataContent && dataContent.length) {
          _interfaceType = interfaceType;
          const { nets, excludeNets } = this.filterExcludeNets(clkSignalNets);
          clkSignalNets = nets;

          let name = clkKey;
          const { icComps } = this.getICComponents({
            nets: clkSignalNets,
            excludeNets,
            icComponents
          })

          ICComps = icComps;
          if (icComps && icComps.length > 1) {
            this.selectNets = [...this.selectNets, filterCLKNet, ...clkSignalNets, ...dataSignalNetList]
            content = [
              { name: name, nets: [...clkSignalNets], signalType: interfaceType === UART ? "TX" : 'CLK', clkNet: filterCLKNet },
              ...dataContent.map(item => { item.signalType = item.signalType ? item.signalType : interfaceType === UART ? "RX" : "DATA"; return item })
            ]
          } else {
            this.addOneChipNetsLog(clkSignalNets, icComps);
            this.addOneChipNetsLog(dataSignalNetList, icComps, "data", clkSignalNets, interfaceType === UART);
          }

        } else {
          this.logList.push({
            type: "Data",
            net: filterCLKNet,
            log: `CLK Net "${filterCLKNet}" does not match data nets.`
          });
        }
        if (content.length) {
          _returnData.push({ content, pcbs, pcbId, type: _interfaceType, ICComps })
        }
      }
    }
    return _returnData;
  }

  getDataNetInfo({ dataNameList, filterCLKNet, clkKey, clkSignalNets, ISConnectTwoComp, types, componentNetList }) {
    const { advancedConfig, netsList, layers, pcbId, type, currentPcbSetting } = this;
    const { compPrefixLib, doNotStuff, passiveTable, compPinMap } = currentPcbSetting;

    const _clkComponentsList = getComponentsWithNetList({ netList: clkSignalNets, pcbNetsList: netsList, layers, pcbId, COMP_PREFIX_LIB: compPrefixLib, doNotStuff, passiveTable, compPinMap });
    const CLKCompNetList = _clkComponentsList.filter(compNet => probePinsPointTypes.includes(compNet.type));
    const CLKNetCompListNames = CLKCompNetList.map(info => info.name);
    const splitNetData = filterCLKNet.split("_")
    let sameData = splitNetData.filter(item => item.toLowerCase() !== clkKey.toLowerCase());
    let newClkSignalNets = JSON.parse(JSON.stringify(clkSignalNets));
    let dataSignalNetList = [];

    if (type === I2S) {
      return this.getI2SDataNetInfo({
        filterCLKNet,
        componentNetList,
        splitNetData,
        clkKey,
        CLKNetCompListNames,
        ISConnectTwoComp,
        dataNameList,
        clkSignalNets
      })
    } else {
      for (let dataName of dataNameList) {
        let content = [], allDataNets = [], allNets = [];
        if (type === SPIQSPIeSPI) {
          this.getSPIQSPIESPIDataNetInfo({
            filterCLKNet,
            componentNetList,
            dataName,
            splitNetData,
            sameData,
            clkKey,
            clkSignalNets,
            allDataNets,
            allNets
          })
        } else {
          for (let dataKey of advancedConfig[dataName]) {
            // Find one of the most eligible nets
            const dataNetName = this.findDataNet({ filterCLKNet, dataKey, clkData: clkKey })
            if (dataNetName && !allNets.includes(dataNetName) && !clkSignalNets.includes(dataNetName)) {
              allDataNets.push({ nets: [dataNetName], filterData: [dataKey] })
              allNets.push(dataNetName);
            } else {
              this.logList.push({
                type: "DataGroup",
                net: filterCLKNet,
                log: `Net "${filterCLKNet}" does not belong to any ${dataName} group.`
              });
            }
          }
        }

        if (allDataNets.length) {
          const new_data = this.getAllDataSignalNets(allDataNets, CLKNetCompListNames, ISConnectTwoComp, clkSignalNets, types)
          let findNameList = [];
          for (let dataNetInfo of new_data) {
            const { nets, filterData, dataNet } = dataNetInfo;
            const findName = filterData.find(it => advancedConfig[dataName].find(ite => it.toLowerCase().includes(ite.toLowerCase())))
            let name = [SPIQSPIeSPI].includes(type) ? getSignalName(findName || filterData[0], nets[0]) || nets[0] : findName;
            if (name) {
              if (findNameList.includes(name) && ![SPIQSPIeSPI].includes(type)) {
                name = getSignalName(findName, nets[0])
              }
              findNameList = [...findNameList, name];
              const sameNet = newClkSignalNets.filter(item => nets.includes(item));
              let new_nets = [...nets]
              if (sameNet.length) {
                // have the same nets
                newClkSignalNets = newClkSignalNets.filter(item => item.includes(clkKey) || !nets.includes(item))
                const _newClkSignalNets = newClkSignalNets;
                new_nets = nets.filter(item => !_newClkSignalNets.includes(item))
              }
              dataSignalNetList.push(...new_nets);
              content.push({ name, nets: [...new_nets], dataNet });
            }
          }
        }

        if (([QSPI, ESPI].includes(dataName) && content.length > 2)
          || (dataName === SPI && content.length > 1)
          || (![QSPI, ESPI, SPI].includes(dataName) && content.length)) {
          const { chipSelectContent, chipSelectNetList = [] } = this.getChipSelect({ filterCLKNet, allDataNets, CLKNetCompListNames, dataContent: content, clkKey, clkSignalNets })
          const sortContent = content.sort(typeSort)
          let _type = types.length === 1 ? types[0] : types.find(item => filterCLKNet.includes(item))
          /*    if (_type === SPI && content.length > 3) { _type = QSPI } */
          // get Type
          if (!_type) { _type = dataName && type === SPIQSPIeSPI ? dataName : types[0] }
          return { dataContent: [...sortContent.map(item => { item.sigType = "DATA"; return item }), ...chipSelectContent], dataSignalNetList: [...dataSignalNetList, ...chipSelectNetList], interfaceType: _type, newClkSignalNets }
        }

      }
    }
    return {}
  }

  getCustomSignals = (pcbs) => {
    const { advancedConfig } = this;
    let _returnData = [];
    let content = [], _interfaceType = '';
    const firstSignal = advancedConfig.signalDefinitions[0];
    const allSignalList = advancedConfig.signalDefinitions.filter((item, index) => index > 0);

    //signal net name ,type keywords
    const keywords = firstSignal.keywords;
    if (!keywords || !keywords.length) {
      this.logList.push({
        type: "SignalNetNamePrefix",
        net: "",
        log: `The keywords in Signal - ${firstSignal.name} are either empty or have a formatting error.`
      })
      return _returnData;
    }

    const { pcbId } = this;

    // Expand keywords containing [N] to explicit tokens for matching (DQ[N] -> DQ0..DQ10)
    const expandedKeywords = [];
    for (const kw of keywords) {
      if (/\[N\]/.test(kw)) {
        const base = kw.replace(/\[N\]/g, '');
        for (let i = 0; i <= 10; i++) {
          expandedKeywords.push(`${base}${i}`);
        }
      } else {
        expandedKeywords.push(kw);
      }
    }

    const reg = getStrListReg(expandedKeywords);
    let signalNetList = this.filterNetsByCLKKeywords([reg], [CUSTOM], firstSignal.name);

    for (let configInfo of signalNetList) {
      const { mName: signalNet } = configInfo;
      let nameList = []
      // Tokenize signalNet and match keywords by token (avoid substring matches like 'd' -> 'TDI')
      const signalTokens = signalNet.split(/[_/]/).map(t => t.toLowerCase()).filter(Boolean);
      let signalKey = "";
      const currKeyWord = keywords.find(orig => {
        if (/\[N\]/.test(orig)) {
          const base = orig.replace(/\[N\]/g, '').toLowerCase();
          const findKey = signalTokens.find(tok => {
            if (!tok.startsWith(base)) return false;
            const rest = tok.slice(base.length);
            if (!rest) return false;
            if (!/^\d+$/.test(rest)) return false;
            const n = Number(rest);
            return n >= 0 && n <= 10;
          });
          if (findKey) {
            signalKey = expandedKeywords.find(kw => kw.toLowerCase() === findKey);
          }
          return findKey ? true : false;
        }
        return signalTokens.some(tok => tok === orig.toLowerCase());
      });

      if (!signalKey) {
        signalKey = currKeyWord;
      }
      const otherKeyWords = keywords.filter(it => it !== currKeyWord);
      let otherSignal = otherKeyWords.length ? { ...firstSignal, keywords: [...otherKeyWords] } : null;
      let signalList = otherSignal ? [otherSignal, ...JSON.parse(JSON.stringify(allSignalList))] : [...JSON.parse(JSON.stringify(allSignalList))]
      const { excludeNets: clkExcludeNets } = this.filterExcludeNets([signalNet]);
      if (clkExcludeNets && clkExcludeNets.includes(signalNet)) {
        continue;
      }
      if (this.getIsPowerGNDNets(configInfo, this.LayoutData.mSymbolMgr, advancedConfig)) { continue }
      this.relatedGroups = new RelateNetsGroup();
      this.relatedGroups.setCompPinsNets(this.pcbId);

      if (this.selectNets.includes(signalNet)) { continue }
      let { relateNets: signalNets, icComponents } = this.getRelateNetsByNetInfo(configInfo)

      signalNets = [...new Set([signalNet, ...signalNets])]
      const { nets } = this.filterExcludeNets(signalNets);
      signalNets = nets;

      if (signalNets && signalNets.length) {
        _interfaceType = advancedConfig.interfaceType;
        nameList.push(firstSignal.name);

        const { signalContent, allSignalNetList, newFirstSignalNets } = this.getCustomSignalsByFirstSignal({
          signalList,
          signalNet,
          signalKey,
          signalNets,
          ISConnectTwoComp: true,
          types: [CUSTOM],
          sigName: firstSignal.name,
          nameList
        })
        if (newFirstSignalNets && newFirstSignalNets.length) {
          signalNets = [...signalNets];
        }
        const { nets, excludeNets } = this.filterExcludeNets(signalNets);
        signalNets = nets;

        const { icComps } = this.getICComponents({
          nets: signalNets,
          excludeNets,
          icComponents
        })

        const ICComps = icComps || [];
        if (icComps && icComps.length > 1) {
          this.selectNets = [...this.selectNets, ...signalNets, ...(allSignalNetList || [])]
          content = [
            {
              name: firstSignal.name,
              nets: [...signalNets],
              signalType: firstSignal.signalType,
              clkNet: signalNet,
              searchSignalName: firstSignal.name,
              dataKey: signalKey
            },
            ...(signalContent || []).map(item => {
              item.signalType = item.signalType ? item.signalType : "DATA";
              return item
            })
          ];

          // The clock signal shares at least one token (delimited by '_' or '/') with at least one data signal.
          /*     const clkTokens = signalNet.split(/[_/]/).map(t => t.toLowerCase()).filter(Boolean);
              const dataNets = (signalContent || []).flatMap(it => it.nets || []);
              const hasShared = dataNets.some(net => {
                const tokens = net.split(/[_/]/).map(t => t.toLowerCase()).filter(Boolean);
                return tokens.some(t => clkTokens.includes(t));
              }); */

          /*    if (hasShared) { */
          _returnData.push({ content, pcbs, pcbId, type: _interfaceType, ICComps })
          /*    } else {
               this.logList.push({
                 type: "DataGroup",
                 net: signalNet,
                 log: `Signal ${firstSignal.name} - Net "${signalNet}" does not belong to any signal group.`
               });
             } */
        } else {
          this.addOneChipNetsLog(signalNets, icComps);
          this.addOneChipNetsLog(allSignalNetList || [], icComps, "data", signalNets, _interfaceType === UART);
        }
      } else {
        this.logList.push({
          type: "Data",
          net: signalNet,
          log: `Signal ${firstSignal.name} - does not match any nets.`
        });
      }
    }
    return _returnData
  }


  getCustomSignalsByFirstSignal = ({
    signalList,
    signalNet,
    signalKey,
    signalNets,
    ISConnectTwoComp,
    types,
    sigName,
    nameList
  }) => {
    const { netsList, layers, pcbId, currentPcbSetting } = this;
    const { compPrefixLib, doNotStuff, passiveTable, compPinMap } = currentPcbSetting;

    const _signalComponentsList = getComponentsWithNetList({ netList: signalNets, pcbNetsList: netsList, layers, pcbId, COMP_PREFIX_LIB: compPrefixLib, doNotStuff, passiveTable, compPinMap });
    const compNetList = _signalComponentsList.filter(compNet => probePinsPointTypes.includes(compNet.type));
    const netCompListNames = compNetList.map(info => info.name);
    let newFirstSignalNets = JSON.parse(JSON.stringify(signalNets));
    let allSignalNetList = [];
    /*     signalContent, allSignalNetList, interfaceType, newFirstSignalNets */
    let allDataNets = [], allNets = [], content = [];
    for (let sigItem of signalList) {
      // Prepare expanded keyword list for this sigItem (support [N] -> 0..10)
      const expandedKeys = [];
      for (const kw of sigItem.keywords || []) {
        if (/\[N\]/.test(kw)) {
          const base = kw.replace(/\[N\]/g, '');
          for (let i = 0; i <= 10; i++) {
            expandedKeys.push(`${base}${i}`);
          }
        } else {
          expandedKeys.push(kw);
        }
      }

      for (let dataKey of expandedKeys) {
        // Find one of the most eligible nets
        const dataNetName = this.findDataNet({ filterCLKNet: signalNet, dataKey, clkData: signalKey });
        if (dataNetName && !allNets.includes(dataNetName) && !signalNets.includes(dataNetName)) {
          allDataNets.push({ nets: [dataNetName], name: sigItem.name, sigType: sigItem.signalType, searchSignalName: sigItem.name, dataKey })
          allNets.push(dataNetName);
        } else {
          this.logList.push({
            type: "DataGroup",
            net: signalNet,
            log: `No corresponding net was found for ${sigItem.name}, which is grouped with ${sigName}(Net - ${signalNet}).`
          });
        }
      }
    }

    if (allDataNets.length) {
      const new_data = this.getAllDataSignalNets(allDataNets, netCompListNames, ISConnectTwoComp, signalNets, types)
      for (let dataNetInfo of new_data) {
        const { name, nets, dataNet, sigType, searchSignalName, dataKey } = dataNetInfo;
        const sameNet = newFirstSignalNets.filter(item => nets.includes(item));
        let new_nets = [...nets]
        if (sameNet.length) {
          // have the same nets
          newFirstSignalNets = newFirstSignalNets.filter(item => item.includes(signalKey) || !nets.includes(item))
          const _newClkSignalNets = newFirstSignalNets;
          new_nets = nets.filter(item => !_newClkSignalNets.includes(item))
        }
        allSignalNetList.push(...new_nets);

        let newName = ""
        if (name && !nameList.includes(name)) {
          newName = name
        } else {
          newName = getDefaultName({ nameList, defaultKey: name, key: "", delimiter: "_", firstIndex: 1 })
        }
        nameList.push(newName)
        content.push({ name: newName, nets: [...new_nets], dataNet, signalType: sigType, searchSignalName, dataKey });
      }
    }

    if (content.length) {
      const sortContent = content.sort(typeSort)
      return {
        signalContent: [...sortContent],
        allSignalNetList: [...allSignalNetList],
        newFirstSignalNets
      }
    }

    return {}
  }

  getI2SDataNetInfo = ({
    filterCLKNet,
    componentNetList,
    splitNetData,
    clkKey,
    CLKNetCompListNames,
    ISConnectTwoComp,
    dataNameList,
    clkSignalNets
  }) => {

    const { advancedConfig, type } = this;
    let allDataNets = [], content = [], dataSignalNetList = [], dataNameNetGroup = {};

    for (let dataName of dataNameList) {
      dataNameNetGroup[dataName] = [];
      let exist = false, existDataNames = []
      for (let compNet of componentNetList) {
        if (compNet === filterCLKNet) { continue }
        const sameData = splitNetData.filter(item => !item.toLowerCase().includes(clkKey.toLowerCase()));
        const splitCompNetDatas = compNet.split("_");
        let diffData = getArrDifference(sameData, splitCompNetDatas)
        const same = arrHasSameValue(filterCLKNet, compNet)
        if (diffData && diffData.length === 1) {
          //compNet: I2S_DAT_1 -> splitCompNetDatas:["I2S","DAT","1"] -> filterDataList: ["DAT"]
          const filterDataList = splitCompNetDatas.filter(it => !sameData.includes(it) && isNaN(Number(it)));

          if (filterDataList && filterDataList.length) {
            let filterData = filterDataList[0];

            if (advancedConfig[dataName].find(it => filterData.toLowerCase().includes(it.toLowerCase()))) {
              existDataNames.push(...advancedConfig[dataName].filter(it => filterData.toLowerCase().match(it.toLowerCase())))
              allDataNets.push({ nets: [compNet], name: filterData, signalType: dataName === "SD" ? "DATA" : dataName })
              exist = true;
            } else {
              this.logList.push({
                type: "DataGroup",
                net: compNet,
                log: `Net "${compNet}" does not belong to any ${type} group.`
              });
            }
          } else {
            this.logList.push({
              type: "DataGroup",
              net: compNet,
              log: `Net "${compNet}" does not belong to any ${type} group.`
            });
          }
        } else {
          if (advancedConfig[dataName].find(it => splitCompNetDatas.find(key => key.toLowerCase().includes(it.toLowerCase())))) {
            dataNameNetGroup[dataName].push({
              net: compNet,
              same,
              splitCompNetDatas
            })
          }
          this.logList.push({
            type: "DataGroup",
            net: compNet,
            log: `Net "${compNet}" does not belong to any ${type} group.`
          });
        }
      }

      if (!exist || Object.keys(dataNameNetGroup).find(key => dataNameNetGroup[key].length)) {
        const allDataList = dataNameNetGroup[dataName].sort((a, b) => { return b.same.length - a.same.length });
        // const maxSameLength = allDataList[0] ? allDataList[0].same.length : 1;
        if (dataName === SD) {
          for (let dataItem of allDataList) {
            if (!dataItem.same.length) {
              break;
            }
            const filterData = dataItem.splitCompNetDatas.find(item => advancedConfig[dataName].find(it => item.toLowerCase().includes(it.toLowerCase())));
            const netDataNames = advancedConfig[dataName].filter(it => filterData.toLowerCase().match(it.toLowerCase()));
            //filter exist data name
            if (existDataNames.find(it => netDataNames.includes(it))) {
              continue;
            }
            if (netDataNames.length) {
              existDataNames.push(...netDataNames)
            }
            allDataNets.push({ nets: [dataItem.net], name: filterData ? filterData : dataItem.splitCompNetDatas[0], signalType: "DATA" })
          }
        } else if (allDataList[0] && allDataList[0].same.length) {
          const filterData = allDataList[0].splitCompNetDatas.find(item => advancedConfig[dataName].find(it => item.toLowerCase().includes(it.toLowerCase())))
          allDataNets.push({ nets: [allDataList[0].net], name: filterData ? filterData : allDataList[0].splitCompNetDatas[0], signalType: dataName })
        }
      }
    }

    if (allDataNets.length) {
      const new_data = this.getAllDataSignalNets(allDataNets, CLKNetCompListNames, ISConnectTwoComp, clkSignalNets)
      let nameList = [];
      content = new_data.map(item => {
        dataSignalNetList = [...dataSignalNetList, ...item.nets];
        let newName = ""
        if (item.name && !nameList.includes(item.name)) {
          newName = item.name
        } else {
          const names = getInterDefaultName({ nameList, defaultKey: item.name, key: "" })
          newName = names[0];
        }
        nameList.push(newName)

        return { name: newName, nets: item.nets, signalType: item.signalType }
      })
    }

    if (content && content.length) {
      return { dataContent: content, dataSignalNetList, interfaceType: type }
    }
    return {};
  }

  getSPIQSPIESPIDataNetInfo = ({
    filterCLKNet,
    componentNetList,
    dataName,
    splitNetData,
    sameData,
    clkKey,
    clkSignalNets,
    allDataNets,
    allNets
  }) => {
    const { advancedConfig } = this;

    const SPIRule = dataName === 'SPI' ? `(SPI)` : `(SPI)|(${dataName})`;
    const typeReg = new RegExp("(QSPI)|(ESPI)", 'i');
    const _rule = new RegExp(SPIRule, 'i');
    const findDataType = splitNetData.find(item => item.match(_rule));
    if (!findDataType) {
      this.logList.push({
        type: "Data",
        net: filterCLKNet,
        log: `Net "${filterCLKNet}" does not contain either ${dataName} keywords.`
      });
      return allDataNets;
    }

    //SPI_CLK, SPI_MISO_D0
    //SPI_CUSTOM_CLK, SPI_CUSTOM_D0_
    let dataNameKey = {}
    let noGroupNets = [], dataNames = [...advancedConfig[dataName].map(item => {
      if (item.match(/\[N\]/)) {
        //DQ[N] -> DQ0,DQ1,...DQ4
        const key = item.replace(/\[N\]/, '');
        const names = [0, 1, 2, 3, 4].map(it => { const type = `${key}${it}`; dataNameKey[type] = item; return type });
        return [...names]
      }
      return [item];
    }).flat(2)];
    for (let compNet of componentNetList) {
      if (allNets.includes(compNet) || clkSignalNets.includes(compNet)) {
        continue;
      }
      const splitCompNetData = compNet.split("_");

      if (sameData.every(it => splitCompNetData.includes(it))) {
        const filterData = splitCompNetData.filter(it => !sameData.includes(it) && isNaN(Number(it)))
        // Find multiple groups of nets that meet the conditions
        if (filterData && filterData.length) {
          const _dataNames = [...dataNames];
          if (filterData.every(it => _dataNames.find(ite => it.toLowerCase().includes(ite.toLowerCase())))) {
            allNets.push(compNet);
            const currDataType = dataNames.filter(it => filterData.find(ite => ite.toLowerCase().includes(it.toLowerCase()))).sort((a, b) => { return b.length - a.length })[0];
            dataNames = dataNames.filter(it => currDataType.toLowerCase() !== it.toLowerCase());
            allDataNets.push({ nets: [compNet], filterData })
          } else {
            noGroupNets.push(compNet)
          }
        } else {
          noGroupNets.push(compNet)
        }
      } else {
        noGroupNets.push(compNet)
      }
    }

    if (!allDataNets.length || dataNames.length) {
      // const filterCLKNet = 'MCASP2_AXR3/SPI3_CLK', clkKey = 'CLK', dataName = 'SPI', advancedConfig = { SPI: ['D'] };
      // const componentNetList = ['MCASP2_AXR3/SPI3_CLK', 'MCASP2_AFSX/SPI3_D0', 'MCASP2_ACLKX/SPI3_D1']
      // MCASP2_AXR3/SPI3_CLK   MCASP2_AFSX/SPI3_D0    MCASP2_ACLKX/SPI3_D1
      // When there is a slash in netName
      //find clk key MCASP2_AXR3/SPI3_CLK -> SPI3_CLK
      const newSplitCLKName = filterCLKNet.split("/").find(item => item.toLowerCase().includes(clkKey.toLowerCase()));

      for (let dataKey of dataNames) {
        //SPI3_CLK -> SPI3_D0 / SPI_D / SPI_MISO
        const replaceReg = new RegExp(clkKey, "ig");
        const _dataName = (newSplitCLKName || filterCLKNet).replace(replaceReg, dataKey);
        //[MCASP2_AXR3/SPI3_D0, MCASP2_AXR3/SPI3_D, MCASP2_AXR3/SPI3_MISO]
        let newFilterDataName = componentNetList.filter(item => item.toLowerCase().includes(_dataName.toLowerCase()))
        if (newFilterDataName.length) {
          let isSet = false;
          newFilterDataName.forEach(item => {
            //splitName -> SPI3_D0, SPI3_MISO, SPI3_DO1
            const splitName = item.split("/").find(it => it.toLowerCase().includes(dataKey.toLowerCase()));
            if (newSplitCLKName && splitName && newSplitCLKName.split('_').length === splitName.split('_').length && !allNets.includes(item)) {
              allNets.push(item);
              allDataNets.push({ nets: [item], filterData: [dataKey] })
              noGroupNets.push(item);
              isSet = true;
            }
          })
          if (isSet) {
            dataNames = dataNames.filter(it => dataKey !== it)
          }
        }
      }
    }

    if (!allDataNets.length || dataNames.length) {
      // QUP0_SE4_SPI_SCLK
      // QUP0_SE4_I2C_SDA_SPI_MISO   QUP0_SE4_I2C_SCL_SPI_MOSI
      // QUP0_SE4_SPI_CS0_L QUP0_SE4_SPI_CS1_L
      for (let dataKey of dataNames) {
        // Find one of the most eligible nets
        const dataNetName = this.findDataNet({ filterCLKNet, dataKey, clkData: clkKey })

        const isOtherGroup = dataName === 'SPI' && dataNetName && dataNetName.match(typeReg);
        if (dataNetName && !allNets.includes(dataNetName) && !clkSignalNets.includes(dataNetName) && !isOtherGroup) {
          allNets.push(dataNetName);
          allDataNets.push({ nets: [dataNetName], filterData: [dataKey] })
        } else {
          this.logList.push({
            type: "DataGroup",
            net: filterCLKNet,
            log: `Net "${filterCLKNet}" does not belong to any ${dataName} group.`
          });
        }
      }
    }

    for (let net of noGroupNets) {
      if (allNets.includes(net)) {
        continue;
      }
      this.logList.push({
        type: "DataGroup",
        net: net,
        log: `Net "${net}" does not belong to any ${dataName} group.`
      });
    }


    return allDataNets;
  }

  filterDataContent = (allData) => {
    let netMaxPrefix = {};

    for (let i = 0; i < allData.length; i++) {
      const daItem = allData[i];
      daItem.key = `${daItem.type}-${i}`;
      allData[i].key = daItem.key;
      const clkSignal = daItem.content.find(item => item.name.match(/clk/i));
      if (!clkSignal) {
        continue;
      }
      const clkNet = clkSignal.clkNet;

      /*     let notSameData = [] */
      for (let sigItem of daItem.content) {
        if (sigItem.name.match(/clk/i)) {
          continue;
        }
        const maxPrefixStr = _maxPrefix([clkNet, sigItem.dataNet]);
        /*   if (!maxPrefixStr) {
            notSameData.push(sigItem.name);
            continue;
          } */
        let dataNetInfo = {
          clkNet,
          maxPrefixStr,
          key: daItem.key,
          name: sigItem.name
        }
        const findSameDataNets = sigItem.nets.filter(item => !!netMaxPrefix[item]);
        if (findSameDataNets.length) {
          for (let net of findSameDataNets) {
            const maxPrefixStr = _maxPrefix([clkNet, net]);
            netMaxPrefix[net].push({
              clkNet,
              maxPrefixStr,
              key: daItem.key,
              name: sigItem.name
            })
          }
        }
        if (!netMaxPrefix[sigItem.dataNet]) {
          netMaxPrefix[sigItem.dataNet] = [dataNetInfo]
        } else {
          netMaxPrefix[sigItem.dataNet].push(dataNetInfo)
        }
      }
      //  daItem.content = daItem.content.filter(item => !notSameData.includes(item.name));
    }
    let filterSignals = []
    for (let key of Object.keys(netMaxPrefix)) {
      netMaxPrefix[key] = netMaxPrefix[key].sort((a, b) => b.maxPrefixStr.length - a.maxPrefixStr.length);
      const maxPrefixStr = netMaxPrefix[key][0].maxPrefixStr;
      const filters = netMaxPrefix[key].filter(item => item.maxPrefixStr.length === maxPrefixStr.length);
      if (filters.length) {
        filterSignals = [...filterSignals, ...filters];
      }
    }

    allData.forEach(item => {
      item.content = item.content.filter(it =>
        !netMaxPrefix[it.dataNet] || netMaxPrefix[it.dataNet].length <= 1
        || filterSignals.find(sig => it.name === sig.name && item.key === sig.key));

      const dataContent = item.content.filter(item => item.sigType === "DATA");
      if (item.type === SPI && dataContent.length > 3) { item.type = QSPI }
    })
    return allData;
  }

  getCLKTypeClkNet({ isDifferential }) {
    // fbest matching netilter CLK Net
    let filterNetList = [], notSelectNet = [];
    for (let configInfo of this.componentNetInfoList || []) {
      const { mName: filterCLKNet } = configInfo;
      if (notSelectNet.includes(filterCLKNet)) { continue }
      let find = '';
      const pReg = new RegExp(`(P)|(\\+)`, 'ig');
      const nReg = new RegExp(`(N)|(\\-)`, 'ig');
      const pNetStr = strReplaceAll(strReplaceAll(filterCLKNet, pReg, "N"), nReg, "N");
      //Find differential nets
      find = this.componentNetInfoList.find(net => net.mName !== filterCLKNet && strReplaceAll(strReplaceAll(net.mName, pReg, "N"), nReg, "N") === pNetStr);

      if (find) {
        notSelectNet = [...notSelectNet, find.mName, filterCLKNet];
        if (isDifferential) {
          filterNetList = [...filterNetList, find, configInfo];
        } else {
          this.logList.push({
            type: "DifferenceNets",
            net: filterCLKNet,
            log: `Net "${filterCLKNet}", "${find.mName}" are differential nets.`
          })
        }

      } else if (!isDifferential /* && (!rule || (rule && !rule.test(filterCLKNet))) */) {
        //custom rule is null, CLK -> filter i2c/i2s ...
        filterNetList = [...filterNetList, configInfo]
      } else {
        this.logList.push({
          type: "DifferenceNets",
          net: filterCLKNet,
          log: `Net "${filterCLKNet}" is not a differential net.`
        })
      }
    }
    return [...new Set(filterNetList)];
  }
}

function getStrListReg(list, returnStr = false) {
  let reg = "", str = "";
  if (!Array.isArray(list)) {
    return returnStr ? { reg, str } : reg;
  }

  const _list = list.map(item => strFormatChange(item))
  str = _list.join('|');
  if (str) {
    reg = new RegExp(`${str}`, "ig");
  }

  return returnStr ? { reg, str } : reg;
}

function getArrDifference(arr1, arr2) {
  return arr1.concat(arr2).filter(function (v, i, arr) {
    return arr.indexOf(v) === arr.lastIndexOf(v);
  });
}

function regularNetName(reg) {
  try {
    const isReg = eval(reg) instanceof RegExp;
    if (isReg) {
      return eval(reg)
    } else {
      const _reg = new RegExp('(' + reg + ')', 'i');
      if (eval(_reg) instanceof RegExp) {
        return _reg
      }
    }
    return false
  } catch (e) {
    try {
      const _reg = new RegExp('(' + reg + ')', 'i');
      if (eval(_reg) instanceof RegExp) {
        return _reg
      }
    } catch (e) {
    }
    return false
  }
}

function arrHasSameValue(arr1, arr2) {
  // Accept either two arrays of tokens or two net name strings.
  // If strings provided, split by '_' or '/' into tokens.
  const tokens1 = typeof arr1 === 'string' ? arr1.split(/[_/]/).map(t => t.toLowerCase()).filter(Boolean) : (Array.isArray(arr1) ? arr1.map(t => (t || '').toString().toLowerCase()) : []);
  const tokens2 = typeof arr2 === 'string' ? arr2.split(/[_/]/).map(t => t.toLowerCase()).filter(Boolean) : (Array.isArray(arr2) ? arr2.map(t => (t || '').toString().toLowerCase()) : []);

  const minLen = Math.min(tokens1.length, tokens2.length);
  const same = [];
  for (let i = 0; i < minLen; i++) {
    if (tokens1[i] && tokens2[i] && tokens1[i] === tokens2[i]) {
      same.push(tokens1[i]);
    }
  }
  return same;
}

function findComponentWithMostPins(ICComps, componentList) {
  let maxPins = -1;
  let result = null;

  for (const comp of ICComps) {
    const component = componentList[comp];
    if (component && component.pinList) {
      const pinCount = component.pinList.length;
      if (pinCount > maxPins) {
        maxPins = pinCount;
        result = comp;
      }
    }
  }

  return result;
}

export default FindInterface;